import request from './request'

// 登录
export function login(username, password) {
  return request({
    url: '/api/user/login',
    method: 'post',
    data: { username, password }
  })
}

// 注册
export function register(data) {
  return request({
    url: '/api/user/register',
    method: 'post',
    data
  })
}

// 获取验证码
export function getCaptcha() {
  return request({
    url: '/api/user/captcha',
    method: 'get'
  })
}

// 发送验证码
export function sendCode(phone, type = 'register') {
  return request({
    url: '/api/user/send-code',
    method: 'post',
    data: { phone, type }
  })
}

// 获取用户信息
export function getUserInfo() {
  return request({
    url: '/api/user/info',
    method: 'get'
  })
}

// 退出登录
export function logout() {
  return request({
    url: '/api/user/logout',
    method: 'post'
  })
}

// 获取系统配置（推广地址、公告等公开配置）
export function getSystemConfig() {
  return request({
    url: '/api/config/system',
    method: 'get'
  })
}

